import { render, staticRenderFns } from "./KInput.vue?vue&type=template&id=ebd34210&scoped=true&"
import script from "./KInput.vue?vue&type=script&lang=js&"
export * from "./KInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd34210",
  null
  
)

export default component.exports